// extracted by mini-css-extract-plugin
module.exports = {"Inf_Image_Card":"Inf_Image_Card--1PecE","title":"title--1L_PE","description":"description--3uMqJ"};